import { CalendarHeader_default } from "../Calendar/CalendarHeader.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerHeader.vue?vue&type=script&setup=true&lang.ts
var DatePickerHeader_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerHeader",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CalendarHeader_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerHeader.vue
var DatePickerHeader_default = DatePickerHeader_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerHeader_default };
//# sourceMappingURL=DatePickerHeader.js.map